module.exports = __webpack_public_path__ + "img/avatar.fc6a7475.png";